export default function classesToSelector() {
  let classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return `.${classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}